/* Mama's Daily — shared JS (Horizon compatible).
   Option/variant picker propagates the selected variant id to every add-to-cart
   button, swaps the variant image, updates the money price and sold-out state,
   and adds to the Horizon cart drawer. Loaded once (module URL de-dupes). */

(function () {
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  function init() { galleries(); thumbNav(); calculators(); packs(); faqs(); reveals(); stickyBar(); atc(); }

  /* ---- gallery ---- */
  function galleries() {
    $$('[data-md-thumbs]').forEach((thumbs) => {
      const main = document.getElementById(thumbs.getAttribute('data-main') || 'md-mainImg');
      $$('button', thumbs).forEach((b) => {
        if (!once(b, 'mdThumb')) return;
        b.addEventListener('click', () => {
          $$('button', thumbs).forEach((x) => x.classList.remove('active'));
          b.classList.add('active');
          if (!main || !b.dataset.src) return;
          main.style.opacity = 0;
          setTimeout(() => { main.src = b.dataset.src; main.style.opacity = 1; }, 180);
        });
      });
    });
  }

  /* ---- side thumbnail slider arrows ---- */
  function thumbNav() {
    $$('[data-md-thumb-nav]').forEach((btn) => {
      if (!once(btn, 'mdNavBound')) return;
      btn.addEventListener('click', () => {
        const col = btn.closest('.thumbs-col') || btn.parentElement;
        const list = col ? col.querySelector('.thumbs') : null;
        if (!list) return;
        const dir = parseInt(btn.dataset.mdThumbNav, 10) || 1;
        const horizontal = getComputedStyle(list).flexDirection === 'row';
        if (horizontal) list.scrollBy({ left: dir * 180, behavior: 'smooth' });
        else list.scrollBy({ top: dir * 180, behavior: 'smooth' });
      });
    });
  }

  /* ---- savings calculator ---- */
  function calculators() {
    $$('.md-calc').forEach((calc) => {
      const spend = $('input[type=range]', calc);
      if (!spend || !once(calc, 'mdCalc')) return;
      const WASTE = parseFloat(calc.dataset.waste) || 0.35;
      const SET   = parseFloat(calc.dataset.setprice) || 29.99;
      const HALVE = parseFloat(calc.dataset.halve) || 0.5;
      const fmt = (n) => '$' + Math.round(n).toLocaleString('en-US');
      const upd = () => {
        const w = +spend.value;
        const sv = $('[data-md-spendval]', calc); if (sv) sv.textContent = '$' + w;
        const waste = w * 52 * WASTE, saved = waste * HALVE;
        const wy = $('[data-md-wasteyear]', calc); if (wy) wy.textContent = fmt(waste);
        const syn = $('[data-md-saveyear]', calc); if (syn) syn.textContent = fmt(saved);
        const wk = SET / (saved / 52);
        const pb = $('[data-md-payback]', calc);
        if (pb) pb.textContent = wk < 1 ? 'under a week' : (wk < 8 ? 'under ' + Math.ceil(wk) + ' weeks' : Math.round(wk) + ' weeks');
      };
      spend.addEventListener('input', upd); upd();
    });
  }

  /* ---- option / variant picker ---- */
  function getSelectedPack() { return document.querySelector('.hopt.pick') || document.querySelector('.hopt'); }

  function applyPack(el) {
    if (!el) return;
    $$('.hopt').forEach((t) => t.classList.remove('pick'));
    el.classList.add('pick');
    const d = el.dataset;

    const pv = parseFloat(d.price), wv = parseFloat(d.was);
    const pct = (wv > 0 && wv > pv) ? Math.round((1 - pv / wv) * 100) : 0;
    const priceStr = d.priceMoney || (isNaN(pv) ? '' : '$' + pv.toFixed(2));
    const wasStr = d.wasMoney || (isNaN(wv) ? '' : '$' + wv.toFixed(2));

    const setId = (id, v) => { const n = document.getElementById(id); if (n) n.textContent = v; };
    setId('md-ctaPrice', priceStr);
    $$('[data-md-sticky-name]').forEach((n) => n.textContent = d.stickyname || ('Fresh-Keeper · Pack of ' + (d.count || '')));
    $$('[data-md-sticky-price]').forEach((n) => n.textContent = priceStr);
    $$('[data-md-sticky-was]').forEach((n) => n.textContent = wasStr);
    $$('.badge-save').forEach((b) => {
      if (pct > 0) { b.textContent = 'Save ' + pct + '%'; b.style.display = ''; }
      else { b.textContent = ''; b.style.display = 'none'; }
    });

    // real variant → every add-to-cart button
    if (d.variantId) $$('[data-md-atc]').forEach((b) => { b.dataset.variant = d.variantId; });

    // variant image swap
    if (d.mediaSrc) {
      const main = document.getElementById('md-mainImg');
      if (main) { main.style.opacity = 0; setTimeout(() => { main.src = d.mediaSrc; main.style.opacity = 1; }, 180); }
    }

    // sold-out state
    const soldout = d.available === 'false';
    $$('[data-md-atc]').forEach((b) => { b.disabled = soldout; b.style.opacity = soldout ? '.55' : ''; });
  }

  function packs() {
    $$('.hopt').forEach((el) => { if (once(el, 'mdPack')) el.addEventListener('click', () => applyPack(el)); });
    const sel = getSelectedPack(); if (sel) applyPack(sel);
  }

  /* ---- faq ---- */
  function faqs() {
    $$('.faq-q').forEach((btn) => {
      if (!once(btn, 'mdFaq')) return;
      btn.addEventListener('click', () => {
        const item = btn.parentElement, a = item.querySelector('.faq-a');
        if (item.classList.contains('open')) { item.classList.remove('open'); a.style.maxHeight = null; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* ---- reveal ---- */
  function reveals() {
    const ro = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); }
    }), { threshold: 0.12 });
    $$('.reveal').forEach((r) => { if (once(r, 'mdReveal')) ro.observe(r); });
  }

  /* ---- sticky bar ---- */
  function stickyBar() {
    const bar = document.getElementById('md-stickyBar');
    if (!bar || !once(bar, 'mdSticky')) return;
    const hero = document.getElementById('md-buy');
    if (hero) {
      new IntersectionObserver(([e]) => {
        if (e.boundingClientRect.top < 0 && !e.isIntersecting) bar.classList.add('show');
        else bar.classList.remove('show');
      }, { threshold: 0 }).observe(hero);
    } else {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 600) bar.classList.add('show'); else bar.classList.remove('show');
      }, { passive: true });
    }
  }

  /* ---- add to cart ---- */
  function atc() {
    $$('[data-md-atc]').forEach((btn) => {
      if (!once(btn, 'mdAtc')) return;
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        const pack = getSelectedPack();
        const qty = Number(pack && pack.dataset.qty) || Number(btn.dataset.qty) || 1;
        const variant = btn.dataset.variantOverride || btn.dataset.variant;
        if (!variant) { window.location.href = '/cart'; return; }
        addToCart(variant, qty, btn);
      });
    });
  }

  /* ---- Horizon cart drawer add-to-cart ---- */
  let _events;
  async function getEvents() {
    if (_events !== undefined) return _events;
    try { _events = await import('@shopify/events'); } catch (e) { _events = null; }
    return _events;
  }

  async function addToCart(variantId, qty, btn) {
    const original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    const addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
    try {
      const ev = await getEvents();
      const ids = [];
      document.querySelectorAll('cart-items-component').forEach((i) => { if (i.dataset.sectionId) ids.push(i.dataset.sectionId); });

      const fd = new FormData();
      fd.set('id', String(variantId));
      fd.set('quantity', String(qty));
      if (ids.length) fd.append('sections', ids.join(','));

      let deferred = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          deferred = ev.CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: String(variantId), quantity: qty }],
            promise: deferred.promise,
          }));
        } catch (e) { deferred = null; }
      }

      const res = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();

      if (!res.ok || data.status) {
        if (deferred && deferred.reject) deferred.reject(new Error(data.message || 'add failed'));
        alert(data.description || data.message || 'Sorry, this could not be added to the cart.');
        return;
      }

      if (deferred && deferred.resolve && ev.CartLinesUpdateEvent.createCartFromAjaxResponse) {
        try {
          const cart = await (await fetch('/cart.js')).json();
          deferred.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { didError: false, items: cart.items, source: 'mamas-daily', itemCount: qty },
            sections: data.sections,
          });
        } catch (e) {
          try { deferred.resolve({ detail: { didError: false, itemCount: qty } }); } catch (_) {}
          await refreshDrawer();
        }
        openDrawer();
      } else {
        await refreshDrawer(); await refreshCount(); openDrawer();
      }
    } catch (e) {
      await refreshDrawer(); await refreshCount(); openDrawer();
    } finally {
      if (btn) { btn.disabled = false; if (original !== null) btn.innerHTML = original; }
    }
  }

  async function refreshDrawer() {
    try {
      const wrap = document.getElementById('shopify-section-cart-drawer-section');
      if (!wrap) return;
      const html = await (await fetch('/?section_id=cart-drawer-section')).text();
      if (html && html.trim()) wrap.innerHTML = html;
    } catch (e) {}
  }
  async function refreshCount() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.cart-bubble, [data-cart-count], .cart-count').forEach((el) => {
        el.textContent = cart.item_count; el.removeAttribute('hidden');
      });
    } catch (e) {}
  }
  function openDrawer() {
    const drawer = document.getElementById('cart-drawer');
    try { if (drawer && typeof drawer.open === 'function') { if (!drawer.isOpen) drawer.open(); return; } } catch (e) {}
    const trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
